import { render, staticRenderFns } from "./CardAnalyticGoalOverview.vue?vue&type=template&id=72c5a24b&"
import script from "./CardAnalyticGoalOverview.vue?vue&type=script&lang=js&"
export * from "./CardAnalyticGoalOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports